import { Routes } from '@angular/router';

import { App404Component } from '@f4rm/app-core/components/404/404.component';
import { AppErrorComponent } from '@f4rm/app-core/components/error/error.component';
import { LayoutComponent } from '@f4rm/app-core/components/layout/layout.component';
import { AppRouterOutletComponent } from '@f4rm/app-core/components/layout/router-outlet.component';
import { LoadingComponent } from '@f4rm/app-core/components/loading/loading.component';
import { authGuard } from '@f4rm/app-core/guards/auth.guard';
import { configLoadedGuard } from '@f4rm/app-core/guards/config-loaded.guard';
import { userLoadedGuard } from '@f4rm/app-core/guards/user-loaded.guard';

export const routes: Routes = [
  // Callback route for OAuth flow - Keycloak redirects here after auth
  {
    path: 'invitation-callback',
    loadComponent: () =>
      import('./pages/invitation/invitation-callback/invitation-callback.component').then(
        (m) => m.InvitationCallbackComponent
      ),
  },
  {
    path: '',
    component: AppRouterOutletComponent,
    canMatch: [configLoadedGuard],
    children: [
      {
        path: '',
        redirectTo: '/app',
        pathMatch: 'full',
      },
      {
        path: 'loading',
        component: LoadingComponent,
      },
      {
        path: 'app',
        component: LayoutComponent,
        loadChildren: () =>
          import('./pages/f4rm.routes').then((m) => m.f4rmhubRoutes),
        data: { preload: false },
        canActivate: [authGuard, userLoadedGuard],
      },
      {
        path: 'exception',
        component: AppErrorComponent,
      },
      {
        path: 'not-found',
        component: App404Component,
      },
    ],
  },
  // Modal outlet routes
  {
    path: 'vocal-assistant',
    outlet: 'modal',
    loadComponent: () =>
      import('./pages/vocal-assistant/vocal-assistant-page/vocal-assistant-page.component').then(
        (m) => m.VocalAssistantPageComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
